import React, { useEffect, useState } from "react";
import "../../../App.scss";

const ModuleTop = ({ module, noAnimate }) => {
  const [active, setActive] = useState(noAnimate);

  useEffect(() => {
    if (!noAnimate) {
      const timer = requestAnimationFrame(() => setActive(true));
      return () => cancelAnimationFrame(timer);
    }
  }, [noAnimate]);

  return (
    <div className={`module-top ${module}`}>
      <div
        className={`module-top-bar ${module} ${active ? "active" : ""} ${
          noAnimate ? "no-animate" : ""
        }`}
      ></div>
      <div className={`module-top-logo ${module}`}></div>
    </div>
  );
};

export default ModuleTop;
